import React, { PropsWithChildren } from "react";

import Footer from "./Footer";
import Navbar from "./Navbar";

const LandingLayout = (props: PropsWithChildren) => {
  return (
    <div className="bg-neutral-background">
      <Navbar />
      {props.children}
      <Footer />
    </div>
  );
};

export default LandingLayout;
